<div class="message" [ngClass]="{'message--modal': isModal}">
  <ng-container *ngTemplateOutlet="message.author ? userWithLink : userWithoutLink"></ng-container>
  <div class="message__content">
    <div class="message__content__text">
      {{ isTranslated && translatedMsg ? translatedMsg : message?.message }}
      <div class="mmao-action" *ngIf="sellerCanMakeAnOffer">
        <button
          class="vc-btn vc-btn--secondary vc-btn--small"
          appOpenMmaoPopin
          [product]="product"
          [negotiation]="negotiation"
          [buyerId]="message.author.id"
          [commentId]="message.id"
          i18n="@@DISCUSSIONS.MSG.SELLER_MMAO_BTN"
        >
          Make a price offer
        </button>
      </div>
      <vc-like
        *ngIf="showLikeFunctionality && likedItem"
        className="message__content__actions__like comment__like"
        [isLiked]="isLiked()"
        [idItem]="message.id"
        [likeCount]="message.nbLike"
        [type]="'comments'"
        [isOldDesign]="true"
      ></vc-like>
    </div>
  </div>
</div>

<ng-template #userWithLink>
  <a
    class="message__user"
    i18n-href="@@PRODUCT.DETAILS.SELLER_PROFILE_LINK"
    [href]="'/membres/profil-' + message?.author?.id + '.shtml'"
  >
    <ng-container *ngTemplateOutlet="userContent"></ng-container>
  </a>
</ng-template>

<ng-template #userWithoutLink>
  <div class="message__user">
    <ng-container *ngTemplateOutlet="userContent"></ng-container>
  </div>
</ng-template>

<ng-template #userContent>
  <div class="message__user__picture">
    <vc-images
      class="message__user__picture__image"
      *ngIf="message?.author?.picture; else authorInitial"
      url="{{ message?.author?.picture?.path }}"
      [width]="'60'"
      [height]="'60'"
      [auto]="format"
      [alt]="message?.author?.firstname"
    ></vc-images>
    <ng-template #authorInitial>
      <div class="message__user__picture__letter">{{ message?.author?.firstname | slice: 0:1 }}</div>
    </ng-template>
  </div>
  <div class="message__user__infos">
    <div class="message__user__infos__name">
      <a [href]="">{{ message?.author?.firstname }}</a>
      <span *ngIf="isSeller" class="message__user__infos__flagSeller"
        ><span i18n="@@DISCUSSIONS.MSG.SELLER">Seller</span></span
      >
    </div>
    <div class="message__user__infos__MsgDate vc-body3" i18n="@@DISCUSSIONS.MSG.DATE">
      {{ dateFormat.date }}, {{ dateFormat.hours }}
    </div>
  </div>
</ng-template>
